module.exports = "/_next/static/images/29d16fd95039695cc4f336f2bf8432d8-card-lg.png.webp";